// extracted by mini-css-extract-plugin
export default {"navigationArrows":"hPfigP","verticalArrows":"w6HXik","up":"UOqrfV","down":"lpvPUC","left":"DAoxVD","right":"kcz7Uz","resetButton":"Q5yJki"};